import { render } from "./Flows.vue?vue&type=template&id=f012c8a4"
import script from "./Flows.vue?vue&type=script&lang=js"
export * from "./Flows.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/Flows.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f012c8a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f012c8a4', __exports__)) {
    api.reload('f012c8a4', __exports__)
  }
  
  module.hot.accept("./Flows.vue?vue&type=template&id=f012c8a4", () => {
    api.rerender('f012c8a4', render)
  })

}


export default __exports__